import { useState, useCallback } from "react";

import { OtpPasswordUIProps } from "./OtpPassword.types.tsx";

import { useLoginContext } from "../../views/Login/Login.context.tsx";

export const useOtpPassword = (): OtpPasswordUIProps => {
  const { onOtpPassword } = useLoginContext();

  const [validated, setValidated] = useState(false);
  const [otp, setOtp] = useState("");

  const handleChange = useCallback((value: string) => {
    setOtp(value);
  }, []);

  const handleSubmit = useCallback(
    async (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      setValidated(true);

      if (otp.length < 6) return;

      await onOtpPassword(otp);
    },
    [otp, onOtpPassword]
  );

  return {
    otp,
    validated,
    handleChange,
    handleSubmit,
  };
};
